module.exports = require('./helpers/bundle-url').getBundleURL('1XeXB') + "logo.c51670a8.svg";